/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

/**
 * Document enrichment availability state for the document intelligence response.
 */
export type DocumentIntelligenceStatus =
    (typeof DocumentIntelligenceStatus)[keyof typeof DocumentIntelligenceStatus];

export const DocumentIntelligenceStatus = {
    Missing: 'Missing',
    Pending: 'Pending',
    InProgress: 'InProgress',
    Failed: 'Failed',
    Completed: 'Completed',
    Malformed: 'Malformed',
} as const;
